import { createSelector } from "@ngrx/store";
import { ReportsState } from '../reducers';


const exportState = (state: ReportsState) => state.export

export const getStagedItems = createSelector(exportState, state => state.entities);
export const getAllStaged = createSelector(exportState, state => Object.keys(state.entities).map(id => state.entities[id]));
// export const getPages = createSelector(exportState, state => state.pages);
export const getEnabled = createSelector(exportState, state => state.enabled);
